import { render, staticRenderFns } from "./SourceRequest.vue?vue&type=template&id=f9323182&scoped=true&"
import script from "./SourceRequest.vue?vue&type=script&lang=js&"
export * from "./SourceRequest.vue?vue&type=script&lang=js&"
import style0 from "./SourceRequest.vue?vue&type=style&index=0&id=f9323182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9323182",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VCardText,VSnackbar})
